'use client';
import parse from 'html-react-parser';
import { FC, useMemo } from 'react';
import { RICH_TEXT_CONTENT_CLASS, sanitizeRichTextHtml } from '@/utils/sanitize-rich-text-html';

type Props = {
  description: string;
  disabled?: boolean;
  placeholder?: string;
};

const DescriptionTab: FC<Props> = ({ description, placeholder }) => {
  const sanitized = useMemo(() => sanitizeRichTextHtml(description), [description]);

  if (!sanitized) {
    return placeholder ? <p className="text-sm text-gray-500 italic">{placeholder}</p> : null;
  }

  return (
    <div
      className={`direction-ltr unicode-bidi-embed writing-mode-lr-tb ${RICH_TEXT_CONTENT_CLASS} text-left`}
    >
      {parse(sanitized)}
    </div>
  );
};

export default DescriptionTab;
